<ng-select
#dropdown
[items]="options"
[(ngModel)]="selectedValue"
[clearable]="false"
[searchable]="false"
(change)="onChange($event)"
[appendTo]="'body'">
</ng-select>